"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyFlashcardBack = exports.AnyFlashcardBackSchema = exports.isAnySentenceFlashcardBack = exports.AnySentenceFlashcardBackSchema = exports.isAnyNonBootcampSentenceFlashcardBack = exports.AnyNonBootcampSentenceFlashcardBackSchema = exports.isWordToSentenceRootFlashcardBack = exports.isWordToSentenceFlashcardBack = exports.isBootcampWordToSentenceFlashcardBack = exports.isWordToPicFlashcardBack = exports.WordToPicFlashcardBackSchema = exports.BasicFlashcardBackInfoSchema = exports.NonBootcampFlashcardBackTypes = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const image_association_types_1 = require("../image_association_types");
const flashcard_back_type_types_1 = require("./flashcard_back_type_types");
const flashcard_common_types_1 = require("./flashcard_common_types");
var NonBootcampFlashcardBackTypes;
(function (NonBootcampFlashcardBackTypes) {
    NonBootcampFlashcardBackTypes[NonBootcampFlashcardBackTypes["WORD_TO_PIC"] = 1] = "WORD_TO_PIC";
    NonBootcampFlashcardBackTypes[NonBootcampFlashcardBackTypes["WORD_TO_SENTENCE"] = 2] = "WORD_TO_SENTENCE";
    NonBootcampFlashcardBackTypes[NonBootcampFlashcardBackTypes["WORD_TO_SENTENCE_ROOT"] = 3] = "WORD_TO_SENTENCE_ROOT";
})(NonBootcampFlashcardBackTypes = exports.NonBootcampFlashcardBackTypes || (exports.NonBootcampFlashcardBackTypes = {}));
exports.BasicFlashcardBackInfoSchema = zod_1.z.object({
    customTranslationId: zod_1.z.string().optional(),
    extendedWordId: zod_1.z.string().optional(),
    flashcardId: zod_1.z.string(),
    id: zod_1.z.string(),
    sentenceWordId: zod_1.z.string().optional(),
    typeName: zod_1.z.string().optional(),
    wordEntryId: zod_1.z.string().optional(),
    wordId: zod_1.z.string().optional(),
});
const FlashcardBackBaseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    images: image_association_types_1.ImageSchema.array(),
    type: zod_1.z.string(),
});
exports.WordToPicFlashcardBackSchema = FlashcardBackBaseSchema.extend(flashcard_common_types_1.WordFlashcardAttributesSchema.shape).extend({ type: flashcard_back_type_types_1.WordToPicFlashcardBackTypeSchema });
exports.isWordToPicFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(exports.WordToPicFlashcardBackSchema);
const BaseSentenceFlashcardBackSchema = FlashcardBackBaseSchema.extend(flashcard_common_types_1.SentenceFlashcardAttributesSchema.shape).extend({
    type: flashcard_back_type_types_1.AnyFlashcardBackTypeSchema,
});
const BootcampWordToSentenceFlashcardBackSchema = BaseSentenceFlashcardBackSchema.extend({
    type: flashcard_back_type_types_1.BootcampWordToSentenceFlashcardBackTypeSchema,
});
exports.isBootcampWordToSentenceFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(BootcampWordToSentenceFlashcardBackSchema);
const WordToSentenceFlashcardBackSchema = BaseSentenceFlashcardBackSchema.extend({
    type: flashcard_back_type_types_1.WordToSentenceTypeSchema,
});
exports.isWordToSentenceFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(WordToSentenceFlashcardBackSchema);
const WordToSentenceRootFlashcardBackSchema = BaseSentenceFlashcardBackSchema.extend({
    type: flashcard_back_type_types_1.WordToSentenceRootTypeSchema,
});
exports.isWordToSentenceRootFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(WordToSentenceRootFlashcardBackSchema);
exports.AnyNonBootcampSentenceFlashcardBackSchema = zod_1.z.union([
    WordToSentenceFlashcardBackSchema,
    WordToSentenceRootFlashcardBackSchema,
]);
exports.isAnyNonBootcampSentenceFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(exports.AnyNonBootcampSentenceFlashcardBackSchema);
exports.AnySentenceFlashcardBackSchema = zod_1.z.union([
    exports.AnyNonBootcampSentenceFlashcardBackSchema,
    BootcampWordToSentenceFlashcardBackSchema,
]);
exports.isAnySentenceFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(exports.AnySentenceFlashcardBackSchema);
exports.AnyFlashcardBackSchema = zod_1.z.union([
    exports.AnySentenceFlashcardBackSchema,
    exports.WordToPicFlashcardBackSchema,
]);
exports.isAnyFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(exports.AnyFlashcardBackSchema);
//# sourceMappingURL=flashcard_back_types.js.map